export enum ContainNameType {
  SymbolJackpotGroup = 'jackpotGroup',
  SymbolImage = 'SymbolImage',
  SymbolPayout = 'SymbolPayout',
  SymbolJp = 'SymbolJP',
  SymbolSpine = 'SymbolSpine',
  SymbolMulpitlierNumber = 'SymbolMulpitlierNumber',
  TotalMultiplierContainer = 'TotalMultiplierContainer',
  TumbleWinAmount = 'TumbleWinAmount',
}
